import { supabase } from '../lib/supabase';

export type NotificacionRow = {
  id: string;
  tipo: string;
  mensaje: string;
  factura_id?: string | null;
  venta_id?: string | null;
  leida: boolean;
  created_at: string;
  usuario_id?: string | null;
  deep_link?: string | null;
};

export async function fetchNotificacionesWeb(
  empresaId: string,
  usuarioId: string | null,
  limit = 10,
  isAdmin = false
): Promise<NotificacionRow[]> {
  if (!empresaId) return [];
  let q = supabase
    .from('notificaciones')
    .select('id, tipo, mensaje, factura_id, venta_id, leida, created_at, usuario_id, deep_link')
    .eq('empresa_id', empresaId)
    .order('created_at', { ascending: false })
    .limit(limit);

  if (!isAdmin && usuarioId) {
    q = q.or(`usuario_id.eq.${usuarioId},usuario_id.is.null`);
  }

  const { data, error } = await q;
  if (error) {
    console.warn('fetchNotificacionesWeb', error.message);
    return [];
  }
  return (data as NotificacionRow[]) || [];
}

export async function fetchNotificacionesCountWeb(
  empresaId: string,
  usuarioId: string | null,
  isAdmin = false
): Promise<number> {
  if (!empresaId) return 0;

  // Mismas reglas que el panel de Alertas: pendientes, no leídas y no pospuestas.
  const { count: alertsCount } = await supabase
    .from('alerts')
    .select('*', { count: 'exact', head: true })
    .eq('empresa_id', empresaId)
    .eq('is_read', false)
    .eq('is_completed', false)
    .or(`is_snoozed.is.null,is_snoozed.eq.false,snooze_until.lte.${new Date().toISOString()}`);

  let notifsQ = supabase
    .from('notificaciones')
    .select('*', { count: 'exact', head: true })
    .eq('empresa_id', empresaId)
    .eq('leida', false)
    .not('usuario_id', 'is', null);

  if (!isAdmin && usuarioId) {
    notifsQ = notifsQ.eq('usuario_id', usuarioId);
  }

  const { count: notifsCount } = await notifsQ;
  return (alertsCount ?? 0) + (notifsCount ?? 0);
}

export async function marcarNotificacionLeidaWeb(notificacionId: string): Promise<void> {
  if (!notificacionId) return;
  const { error } = await supabase
    .from('notificaciones')
    .update({ leida: true })
    .eq('id', notificacionId);
  if (error) console.warn('marcarNotificacionLeidaWeb', error.message);
}

export async function marcarTodasNotificacionesLeidasWeb(
  empresaId: string,
  usuarioId: string,
  isAdmin = false
): Promise<void> {
  if (!empresaId || !usuarioId) return;
  let q = supabase
    .from('notificaciones')
    .update({ leida: true })
    .eq('empresa_id', empresaId)
    .eq('leida', false)
    .not('usuario_id', 'is', null);

  if (!isAdmin) {
    q = q.eq('usuario_id', usuarioId);
  }

  const { error } = await q;
  if (error) console.warn('marcarTodasNotificacionesLeidasWeb', error.message);

  // La campana también cuenta las alertas: marcarlas leídas para que el
  // contador y el panel de Alertas queden iguales.
  const { error: alertsError } = await supabase
    .from('alerts')
    .update({ is_read: true, updated_at: new Date().toISOString() })
    .eq('empresa_id', empresaId)
    .eq('is_read', false)
    .eq('is_completed', false);
  if (alertsError) console.warn('marcarTodasNotificacionesLeidasWeb alerts', alertsError.message);
}

export async function deleteNotificacionWeb(notificacionId: string): Promise<void> {
  if (!notificacionId) return;
  const { error } = await supabase.from('notificaciones').delete().eq('id', notificacionId);
  if (error) console.warn('deleteNotificacionWeb', error.message);
}
